import * as React from "react";
import PropTypes from "prop-types";
import FindInStoreFormPage from "./containers/FindInStoreFormPage";
import FindInStoreResultsPage from "./containers/FindInStoreResultsPage";
import { initGA, raiseGAPageView } from "./analytics";

export class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sizes: [],
      accessories: [],
      initialDOMState: {},
      selectedProductName: '',
      showFindInStoreForm: false,
      showFindInStoreResults: false,
      productSku: "",
      postCode: "",
      selectedSizes: [],
      selectedAccessories: [],
      selectedColor: "",
      selectedColourId: '',
      simpleProductInfo: null
    };
  }

  handleFindInStoreForm = (
    selectedSizes,
    postCode,
    selectedAccessories,
    selectedColor,
    selectedColourId
  ) => {
    this.setState({
      selectedSizes: selectedSizes,
      showFindInStoreForm: false,
      showFindInStoreResults: true,
      postCode: postCode,
      selectedAccessories: selectedAccessories,
      selectedColor: selectedColor,
      selectedColourId: selectedColourId
    });
  }

  getColorConfig(initialDOMState){
    const { colourConfig } = initialDOMState;
    if (colourConfig && colourConfig != ''){
      const config = JSON.parse(JSON.parse(colourConfig));
   
      // First key contains the color configuration. Extract this from the map.
      const keys = Object.keys(config);
      if (keys.length > 0) {
        return config[keys[0]];
      }
    }
    return {};
  }

  componentDidMount() {
    // Initialize google analytics
    const mountElement = document.querySelector("[data-react-findinstore]");
    const initialDOMState = JSON.parse(mountElement.dataset.reactFindinstore__initialstate || "{}");
    const groupedProductData = JSON.parse(initialDOMState.groupedProductData);

    if(initialDOMState.isGrouped){
      const firstColorId = groupedProductData[Object.keys(groupedProductData)[0]].color || ''; // Default colour id of the currently selected product
      const colorConfig = this.getColorConfig(initialDOMState);
      const colorConfigItem = colorConfig[firstColorId];
      const selectedProduct = groupedProductData[firstColorId];
   
      initGA(initialDOMState.gaAccountId);
      raiseGAPageView();
    
       this.setState({
        initialDOMState,
        selectedProductName: initialDOMState.productName ? initialDOMState.productName : '',
        showFindInStoreForm: true,
        sizes: (selectedProduct.items) ? selectedProduct.items.items : [],
        accessories: (selectedProduct.accessories) ? selectedProduct.accessories.items : [],
        selectedColor:  (colorConfigItem) ? colorConfigItem.label : '',
        selectedColourId: (colorConfigItem) ? colorConfigItem.id : ''
      });
    } 
    else {
      this.setState({
        initialDOMState,
        selectedProductName: initialDOMState.productName ? initialDOMState.productName : '',
        showFindInStoreForm: true,
        simpleProductInfo: groupedProductData
      });
    }
  }
  
  setStoreSizes = (id) => {
    const groupedProductData = JSON.parse(this.state.initialDOMState.groupedProductData);
    const sizes = (groupedProductData[id].items) ? groupedProductData[id].items.items : [];
    const accessories = (groupedProductData[id].accessories) ?groupedProductData[id].accessories.items : [];
    this.setState({
      sizes, accessories
    })
  }

  setFindInStoreSelection = (postcode, color, sizes, accessories, selectedColourId) => {
    this.setState({
      postCode: postcode,
      selectedColor: color,
      selectedSizes: sizes,
      selectedAccessories: accessories,
      selectedColourId: selectedColourId
    });
  }

  renderFindInStoreForm = () => {
    if (this.state.showFindInStoreForm) {
      const { selectedColor, selectedSizes, colours, selectedProductName, 
              initialDOMState, sizes, accessories, 
              selectedColourId } = this.state;
      return (
        <FindInStoreFormPage
          initialDOMState={initialDOMState}
          productName={selectedProductName}
          colours={colours}
          handler={this.setFindInStoreSelection}
          sizes={sizes}
          accessories={accessories}
          selectedColor={selectedColor}
          selectedSizes={selectedSizes}
          onFindInStoreClick={this.handleFindInStoreForm} 
          selectedColourId ={selectedColourId}
        />
      );
    }
    return null;
  }

  renderFindInStoreResults = () => {
    if (this.state.showFindInStoreResults) {
      const {
        initialDOMState,
        postCode,
        productSku,
        selectedAccessories,
        selectedColor,
        selectedSizes,
        sizes,
        accessories,
        setFindInStoreSelection,
        selectedColourId,
        simpleProductInfo
      } = this.state;
      return (
        <FindInStoreResultsPage
          simpleProductInfo={simpleProductInfo}
          initialDOMState={initialDOMState}
          updateUserSelection={this.setFindInStoreSelection}
          postCode={postCode}
          productSku={productSku}
          selectedSizes={selectedSizes}
          selectedAccessories={selectedAccessories}
          selectedColor={selectedColor}
          sizes={sizes}
          accessories={accessories} 
          selectedColourId = {selectedColourId}
          changeSizes = {this.setStoreSizes}  
          productLowStockBuffer = {initialDOMState.productLowStockBuffer}   
          productOutOfStockBuffer = {initialDOMState.productOutOfStockBuffer}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <section className="react-findinstore-app bbnt-findinstore">
        {this.renderFindInStoreForm()}
        {this.renderFindInStoreResults()}
      </section>
    );
  }
}

App.propTypes = {

};

export default App;
